import { createApp } from "vue"
import App from "./App.vue";
import router from "./router";
import title from "./mixins/title.js";

// Vue.mixin(title);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSearch,
  faTimes,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faBars,
  faReply,
} from "@fortawesome/free-solid-svg-icons";
import { faCopyright } from "@fortawesome/free-regular-svg-icons";
import {
  faYoutubeSquare,
  // faTwitterSquare,
  faSquareXTwitter,
  faFacebookSquare,
  faInstagram,
  faWeibo,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faSearch,
  faTimes,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faBars,
  faReply,
  faCopyright,
  faYoutubeSquare,
  // faTwitterSquare,
  faSquareXTwitter,
  faFacebookSquare,
  faInstagram,
  faWeibo,
  faLinkedin,
  faInfoCircle
);

// Vue.component("font-awesome-icon", FontAwesomeIcon);

// Vue.config.productionTip = false;

// new Vue({
//   router,
//   render: (h) => h(App),
//   data: {
//     mwnf_website: process.env.VUE_APP_MWNF_WEBSITE,
//     api_website: process.env.VUE_APP_API_ENDPOINT,
//   },
// }).$mount("#app");

let app = createApp(App)
    .use(router)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mixin(title)

app.config.globalProperties.$global = {};
app.config.performance = true;
app.mount("#app")
